import { DateTime } from "luxon";

export default {
  install (Vue) {
    Vue.prototype.$IsoDateTime2Luxon = function (isoDateTime) {
      return DateTime.fromISO(isoDateTime)
    }
  }
}